/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSplitTextFragment} from '@amblique/contentful/app/contentful/fragments/split-text/base-split-text.fragment';

export const FullSplitTextFragment = gql`
  ${BaseSplitTextFragment}

  fragment FullSplitTextFragment on SplitText {
    ...BaseSplitTextFragment
  }
`;
